import { SvgIcon, SvgIconProps } from '@mui/material';

const WifiFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="WifiFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M11.9207 13C10.0925 13 8.45528 13.8176 7.35477 15.1072L6.11758 13.4932C7.5753 11.9576 9.63617 11 11.9207 11C14.2031 11 16.2623 11.9558 17.7198 13.489L16.4828 15.1027C15.3824 13.8157 13.7468 13 11.9207 13Z" />
      <path d="M20.7849 9.49064L19.5614 11.0867C17.5826 9.17563 14.8889 7.99998 11.9207 7.99998C8.95039 7.99998 6.25505 9.17727 4.27586 11.0907L3.05231 9.49456C5.37493 7.32666 8.49288 5.99998 11.9207 5.99998C15.3464 5.99998 18.4627 7.32506 20.7849 9.49064Z" />
      <path d="M23.8371 5.50899L22.617 7.10065C19.7828 4.55132 16.0329 2.99999 11.9207 2.99999C7.80644 2.99999 4.05487 4.55288 1.22015 7.1045L0 5.51279C3.17489 2.70454 7.34874 1 11.9207 1C16.4906 1 20.6627 2.703 23.8371 5.50899Z" />
      <path d="M11.9207 16C9.98766 16 8.42065 17.567 8.42065 19.5C8.42065 21.433 9.98766 23 11.9207 23C13.8537 23 15.4207 21.433 15.4207 19.5C15.4207 17.567 13.8537 16 11.9207 16Z" />
    </SvgIcon>
  );
};

export default WifiFilled;
